import ProductDesc from "@/components/Desc/ProductDesc";
import SText from "@/styles/SText";
import { SourceTypeEnum } from "@/types/common";
import { OrderItemV2 } from "@/types/inventoryV2";
import { Modal, Typography } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import dayjs from "dayjs";
import { t } from "i18next";

interface InventoryDetailV2Props {
    order: OrderItemV2 | null;
    onCancel: () => void;
}

const InventoryDetailV2: React.FC<InventoryDetailV2Props> = ({ order, onCancel }) => {
    const { Title } = Typography;

    const otherItems: DescriptionsItemType[] = [
        {
            key: 'preTime',
            label: t('order.preTime'),
            children: dayjs(order?.order?.preTime).format('YYYY-MM-DD'),
            span: 2
        },
        {
            key: 'reciver',
            label: t('sale.receivingUnit'),
            children: order?.sourceType === SourceTypeEnum.PURCHASE_ITEM ? order?.source?.order.receiver || '-' : '-'
        },
        {
            key: 'receiverAddress',
            label: t('sale.receivingAddress'),
            children: order?.sourceType === SourceTypeEnum.PURCHASE_ITEM ? order?.source?.order.receiverAddress || '-' : '-'
        },
        {
            key: 'receiverContact',
            label: t('purchase.contact'),
            children: order?.sourceType === SourceTypeEnum.PURCHASE_ITEM ? order?.source?.order.receiverContact || '-' : '-'
        },
        {
            key: 'receiverMobile',
            label: t('purchase.phone1'),
            children: order?.sourceType === SourceTypeEnum.PURCHASE_ITEM ? order?.source?.order.receiverMobile || '-' : '-'
        },
        {
            key: 'quantity',
            label: t("order.quantity"),
            children: order?.count || '-'
        },

    ]

    return <Modal
        title={<SText text={order?.order?.number ?? ''} />}
        open={!!order}
        onCancel={onCancel}
        width={800}
        footer={null}
    >
        <Title level={4}>{t("purchase.productInfo")}</Title>
        <ProductDesc product={order?.product || null} showtype="SUPPLIER" />

        <Title level={4}>{t("purchase.sendInfo")}</Title>
        <ProductDesc product={order?.product || null} showtype="OTHER" otherItems={otherItems} />
    </Modal>
}

export default InventoryDetailV2;